import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankCardSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 48,
	viewBox: "0 0 49 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42.5 23.0082V17.1607C42.5 12.2783 39.4584 8.82812 34.5702 8.82812H14.4297C9.55514 8.82812 6.5 12.2783 6.5 17.1607V30.3366C6.5 35.221 9.54152 38.6692 14.4297 38.6692H22.7448",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 19.4258H42.5",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M38.4334 35.9998C36.1508 38.2824 32.4516 38.2824 30.169 35.9998C27.8864 33.7172 27.8864 30.018 30.169 27.7354C32.4516 25.4528 36.1508 25.4528 38.4334 27.7354C40.716 30.018 40.716 33.7172 38.4334 35.9998Z",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.5996 39.166L38.4336 36",
			stroke: "currentColor",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBankCardSearch;
